import "../login.scss";
import "react-toastify/dist/ReactToastify.css";

import React, { Component } from "react";
import { Card, Grid, Button, Input } from "@mui/material";
import { toast } from "react-toastify";
import loginimage from "../../../assets/images/loginimage.svg";
import GooglePlay from "../../../assets/images/Group 28315.svg";
import AppStore from "../../../assets/images/Group 28316.svg";
import { BaseUrl } from "../../../Environment";
import { auth } from "../../../firebase/config";
import LoadingButton from "@mui/lab/LoadingButton";
import { getSecureItem, setSecureItem } from "../../../utilsFunctions";

const axios = require("axios");
class OtpSignin extends Component {
  constructor() {
    super();
    this.state = {
      mobilenum: "",
      validNum: true,
      numError: "none",
      numErrorMessage: "",
      loading: false,
      otpSent: false,
      phoneNumber: "",
      invalidOtp: false,
      otp: "",
      validOtp: true,
      otpError: "none",
      loadingOtp: false,
    };
  }

  validateNum = (mobilenum) => {
    const countryCode = String(getSecureItem("country")?.code);

    if (!mobilenum) {
      return { valid: false, message: "Mobile Number is required" };
    }

    if (mobilenum.startsWith("0")) {
      return { valid: false, message: "First digit cannot be 0" };
    }

    if (!/^\d+$/.test(mobilenum)) {
      return { valid: false, message: "Only digits are allowed" };
    }

    if (countryCode === "91") {
      if (mobilenum.length < 10) {
        return { valid: false, message: "Mobile Number must be 10 digits" };
      }
      if (mobilenum.length > 10) {
        return { valid: false, message: "Mobile Number cannot exceed 10 digits" };
      }
      if (!/^[6-9]/.test(mobilenum)) {
        return { valid: false, message: "Indian mobile must start with 6, 7, 8, or 9" };
      }
    } else {
      if (mobilenum.length < 8) {
        return { valid: false, message: "Mobile Number is too short" };
      }
      if (mobilenum.length > 15) {
        return { valid: false, message: "Mobile Number is too long" };
      }
    }

    return { valid: true, message: "" };
  };
  validNum = (event) => {
    const mobilenum = event.target.value;
    const numVaild = this.validateNum(mobilenum);
    this.setState({
      mobilenum: event.target.value,
      validNum: numVaild,
      numErrorMessage: numVaild.message,
    });
    if (numVaild.valid === false) {
      this.setState({
        numError: "flex",
      });
    } else {
      this.setState({
        numError: "none",
      });
    }
  };

  requestOTPFromServer = async (phoneNumber) => {
    try {
      const userType = getSecureItem("userTypeAY");

      const response = await axios.post(
        BaseUrl + "/user/sendOtp",
        {
          userPhone: phoneNumber,
          usertype: userType,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        this.setState({ otpSent: true, phoneNumber: phoneNumber });
      } else {
        console.log("response.data.message", response.data.message);
        // todo handle error
      }
    } catch (error) {
      console.log("requestOTPFromServer", "error", JSON.stringify(error));
    } finally {
      this.setState({ loading: false });
    }
  };

  onGetOTPClicked = () => {
    this.setState({ loading: true });
    this.requestOTPFromServer(`+${getSecureItem("country")?.code}${this.state.mobilenum}`);
  };

  validateOTP(otpDigit) {
    const re = /^\d{4}$/g;
    return re.test(otpDigit);
  }

  onOtpChanged = (e) => {
    const otpDigit = e.target.value;
    const otpVaild = this.validateOTP(otpDigit);
    this.setState({
      otp: e.target.value,
      validOtp: otpVaild,
      invalidOtp: false
    });
    if (otpVaild === false) {
      this.setState({
        otpError: "flex",
      });
    } else {
      this.setState({
        otpError: "none",
      });
    }
  };

  onVerifyOTPClicked = () => {
    this.setState({ loadingOtp: true });
    this.verifyOTPWithServer(this.state.otp);
  };

  verifyOTPWithServer = async (otp) => {
    try {
      const response = await axios.post(
        BaseUrl + "/user/verifyMobileOtp",
        {
          userPhone: this.state.phoneNumber,
          otp: otp,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (
        response.data &&
        response.data.status === true &&
        response.data.firebaseToken
      ) {
        // login with custom token firebase
        const firebaseToken = response.data.firebaseToken;
        await auth.signInWithCustomToken(firebaseToken);
        // mark this login as fresh login
        setSecureItem("isFreshLogin", "true");
        setSecureItem("defaultPhone", this.state.phoneNumber);
      } else {
        console.log("response.data.message", response.data);
        // todo handle error
      }
    } catch (error) {
      console.log("requestOTPFromServer", "error", error);
      this.setState({
        invalidOtp: true,
      })
      console.log("ss", error.response.data.message);
      
    } finally {
      // console.log("Verified OTP");
      this.setState({ loadingOtp: false });
    }
  };

  componentDidMount() {}

  render() {
    toast.configure({});
    const {
      mobilenum,
      otpSent,
      loading,
      loadingOtp,
      numError,
      otp,
      invalidOtp,
      otpError,
      phoneNumber,
    } = this.state;
    return (
      <Grid container className="loginPage dBlockCss">
        <Grid item md={6} className="paddingLoginGrids">
          <div>
            <div className="firstH3 TextColour">Collect like a PRO!</div>
            <div className="firstH4 TextColour">
              Digital Bharat ka Digital Khata
            </div>
          </div>
          <div>
            <div>
              <img src={loginimage} alt="login" className="loginIMage" />
              <div className="secondH4">
                Digital Ledger Account (Udhar Bahi Khata book) for Credit,
                Lending and Hisab Khitab for small lenders, grocers and
                shopkeepers
              </div>
              <div className="storeButtons">
                <div className="storeButtonsOne">
                  <a href="https://play.google.com/store/apps/details?id=com.lendstack" target="_blank" className="googlePlay">
                    <img
                      src={GooglePlay}
                      alt="googlePlay"
                      className="googlePlay"
                    />
                  </a>
                  {/* <div className="appStore">
                    <img src={AppStore} alt="appStore" className="appStore" />
                  </div> */}
                </div>
                <div className="clickHere">
                  Read our{" "}
                  <a
                    target="_blank"
                    href="https://lendstack.app/#/termsofservice"
                    style={{ textDecoration: "none" }}
                  >
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a
                    target="_blank"
                    href="https://lendstack.app/#/privacypolicy"
                    style={{ textDecoration: "none" }}
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item md={6} className="paddingLoginGrids">
          <Card className="CardDivLogin">
            {otpSent ? (
              <div className="CardDiv4">
                <div className="CardDiv5 HighlightTextColour textLeft">
                  <div className="firstH4 TextColour textLeft">
                    Enter the OTP received on your mobile number {phoneNumber}
                  </div>
                </div>

                <div
                  className={"form-group" + (!otp ? " has-error" : "")}
                  style={{ marginTop: "10px" }}
                >
                  <Input
                    type="number"
                    placeholder="Enter OTP"
                    required
                    name="otp"
                    className="form-control inputBoxContent Fonts SizeFont"
                    fullWidth
                    value={otp}
                    onChange={this.onOtpChanged}
                  />
                  <span style={{ display: otpError }} className="help-block">
                    OTP must be 4 digit.
                  </span>
                  {!otp && (
                    <div
                      className="help-block"
                      // style={{ marginRight: "12rem" }}
                    >
                      OTP is required
                    </div>
                  )}
                  {invalidOtp && (
                    <div
                      className="help-block"
                      // style={{ marginRight: "12rem" }}
                    >
                      OTP is invalid
                    </div>
                  )}
                </div>
                <div className="btnDiv" style={{ marginTop: 10 }}>
                  <LoadingButton
                    variant="outlined"
                    fullWidth
                    className="Fonts btnSizeFont btn"
                    onClick={this.onVerifyOTPClicked}
                    loading={loadingOtp}
                  >
                    Proceed
                  </LoadingButton>
                </div>
              </div>
            ) : (
              <div className="CardDiv4">
                <div className="CardDiv5 HighlightTextColour textLeft">
                  <h4 style={{ margin: 0 }}>Welcome!</h4>
                  <div className="firstH4 TextColour textLeft">
                    Enter your WhatsApp mobile number to get your OTP.
                  </div>
                </div>

                <div
                  className={"form-group" + (!mobilenum ? " has-error" : "")}
                  style={{ marginTop: "10px" }}
                >
                  <Input
                    type="number"
                    placeholder={getSecureItem("country")?.code == 91 ? "10-digit mobile number without prefixes" : "mobile number without country code"}
                    required
                    name="mobilenum"
                    className="form-control inputBoxContent Fonts SizeFont"
                    fullWidth
                    value={mobilenum}
                    /* onChange={(event) => this.setState({ phone: event.target.value })} */ onChange={
                      this.validNum
                    }
                  />
                  <span style={{ display: numError }} className="help-block">
                    {this.state.numErrorMessage}
                  </span>
                  {/* {!mobilenum && (
                    <div
                      className="help-block"
                      // style={{ marginRight: "12rem" }}
                    >
                      Mobile Number is required
                    </div>
                  )} */}
                </div>
                <div className="btnDiv" style={{ marginTop: 10 }}>
                  <LoadingButton
                    variant="outlined"
                    disabled={!mobilenum || !this.state.validNum.valid}
                    fullWidth
                    className="Fonts btnSizeFont btn"
                    onClick={this.onGetOTPClicked}
                    loading={loading}
                  >
                    Next
                  </LoadingButton>
                </div>
                <div className="TextColour linkFontSize textLeft">
              By clicking, I accept the Terms of Service and Privacy Policy.
             </div>
              </div>
            )}
          </Card>
        </Grid>
      </Grid>
    );
  }
}
export default OtpSignin;
